<template>
  <b-badge :variant="variant">{{ row.StockStatus }}</b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue';

export default {
  components: { BBadge },
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    variant() {
      if (!this.row || !this.row.StockStatus) return 'secondary';
      switch (this.row.StockStatus.toLowerCase()) {
        case 'kritik':
          return 'danger';
        case 'minimum altında':
          return 'warning';
        case 'normal':
          return 'success';
        default:
          return 'secondary';
      }
    },
  },
};
</script>